<template>
  <div class="root">
    <div class="center">
      <h1>{{ $t("changeEmailPage.title") }}</h1>
      <p>
        {{ $t("changeEmailPage.description") }}<br />
        {{ $t("changeEmailPage.descriptionNote") }}
      </p>
      <div class="left">
        <text-field
          type="email"
          :label="$t('changeEmailPage.currentEmailLabel')"
          :placeholder="$t('changeEmailPage.currentEmailPlaceholder')"
          name="email-old"
          v-model="oldMailAddress"
          disabled
          class="text-field"
        />
        <text-field
          type="email"
          :label="$t('changeEmailPage.newEmailLabel')"
          :placeholder="$t('changeEmailPage.newEmailPlaceholder')"
          name="email-new"
          v-model="newMailAddress"
          class="text-field"
        />
      </div>
      <div v-if="message" class="info">{{ message }}</div>
      <button :disabled="processing || !oldMailAddress || !newMailAddress" class="button" @click="submit">
        {{ $t("changeEmailPage.submitButton") }}
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import TextField from "@/components/molecules/TextField.vue";
import { Auth, API } from "aws-amplify";
import { showNotifyDialog } from "@/lib/dialog";
import { NolaApiInitializer } from "@/initializer";

export default Vue.extend({
  // NOTE: metaタグの設定
  metaInfo: {
    meta: [
      {
        name: "robots",
        content: "none",
      },
    ],
  },
  components: { TextField },
  data() {
    return {
      oldMailAddress: "",
      newMailAddress: "",
      message: "",
      processing: false,
    };
  },
  async created() {
    const cognitoUser = await Auth.currentUserPoolUser();
    this.oldMailAddress = cognitoUser.attributes.email;
  },
  methods: {
    async submit() {
      this.processing = true;

      const { oldMailAddress, newMailAddress } = this;
      let userId;
      let cognitoId;

      // verify email
      // eslint-disable-next-line no-useless-escape
      if (!newMailAddress.match(/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/)) {
        this.message = this.$t("changeEmailPage.errors.invalidEmailFormat") as string;
        this.processing = false;
        return;
      }

      try {
        const cognitoUser = await Auth.currentUserPoolUser();
        if (cognitoUser) {
          userId = cognitoUser.attributes.sub;
        }
        const cognitoIdentityCredentials = (await Auth.currentCredentials()) as any;
        if (cognitoIdentityCredentials) {
          cognitoId = cognitoIdentityCredentials.data.IdentityId;
        }

        NolaApiInitializer.init();

        await API.post("Rest", "/mail/verificationlink", {
          body: {
            userId,
            cognitoId,
            newMailAddress,
            oldMailAddress,
          },
        });

        this.message = "";
        await showNotifyDialog({
          content: this.$t("changeEmailPage.successMessage") as string,
        });
        this.$router.push({ name: "myPage" });
      } catch (error: any) {
        console.log({ error });
        this.message = error.response.data.handledMessage || error;
      } finally {
        this.processing = false;
      }
    },
  },
});
</script>

<style lang="scss" scoped>
@import "@/style-common.scss";

h1 {
  font-size: var(--font-size-xl);
  margin-top: 30px;
  margin-bottom: 20px;
  color: var(--color-text-normal);
  border-bottom: solid 1px var(--color-border);
  @include mq(sp) {
    font-size: var(--font-size-md);
    margin-top: 0px;
    margin-bottom: 15px;
  }
}
p {
  font-size: var(--font-size-xs);
  color: var(--color-text-low);
}
.root {
  position: relative;
  padding: 10px 0;
  width: 100%;
  height: 100vh;
  color: var(--color-text-on-fixed-bg);
}

.center {
  margin: 15px auto;
  padding: 30px 15px;
  width: 30%;
  min-width: 300px;
  background-color: var(--color-surface-base);
  color: var(--color-text-normal);
  text-align: center;
  border-radius: var(--radius-sm);

  @include mq(sp) {
    margin: 0px auto;
    padding: 15px 0;
    width: 95%;
    min-width: none;
  }
}
.center form {
  padding: 15px 0;
  margin: auto;
  font-size: 16.1px;
  width: 50%;

  @include mq(sp) {
    width: 100%;
  }
}
.left {
  text-align: left;

  .text-field {
    margin-bottom: 1em;
  }
}

.info {
  color: var(--color-warning);
}

.button {
  position: relative;
  margin-top: 15px;
  padding: 12px 50px;
  border-radius: var(--radius-rounded);
  background-color: var(--color-primary);
  font-size: var(--font-size-sm);
  color: var(--color-text-on-fixed-bg);
  border: none;
  cursor: pointer;

  @include hover-overlay;

  &:disabled {
    background-color: var(--color-surface-muted);
    color: var(--color-inactive);
    border: solid 1px var(--color-border);
    cursor: not-allowed;
    &::after {
      display: none;
    }
  }
}
</style>
